module.exports = __webpack_public_path__ + "img/slider-banner-1.3f864112.jpg";